<template>
  <div class="deep-seek-from-servicequality">
    <div v-show="showChat" class="chat-container" :class="{ 'is-zoom-in': isZoomIn }">
      <iframe v-if="src" ref="charIframeRef" :src="src" allow="clipboard-read; clipboard-write" frameborder="0" scrolling="no" />
    </div>
    <div v-show="!showChat" class="chat-trigger" @click="handleTrigger" v-draggable>
      <img class="chat-logo" src="@/assets/images/chatLogo.webp" alt="" />
    </div>
  </div>
</template>
<script>
import { draggable } from '@/common/utils/commonDirective'
export default {
  name: 'DeepSeekHelper',
  directives: { draggable },
  data() {
    return {
      showChat: false,
      src: '',
      isZoomIn: false
    }
  },
  beforeMount() {
    const token = localStorage.getItem('YL_TOKEN') || this.$store.getters.token
    const { VUE_APP_AI_CHAT_URL } = process.env
    this.src = `${VUE_APP_AI_CHAT_URL}?token=${token}&system=outsource`
    console.log(`${VUE_APP_AI_CHAT_URL}?token=${token}`,'1111')
  },
  mounted() {
    this.initChannel()
  },
  methods: {
    handleTrigger(e) {
      if (e.target.getAttribute('data-dragging')) return
      this.showChat = !this.showChat
    },
    initChannel() {
      const { VUE_APP_AI_CHAT_URL } = process.env
      const channel = new MessageChannel()
      const iframe = this.$refs.charIframeRef

      if (!iframe) {
        console.warn('⚠️ Failed to load iframe. Please check your network or the target URL.')
        return
      }
      iframe.onload = () => {
        iframe.contentWindow.postMessage('initChannel', VUE_APP_AI_CHAT_URL, [channel.port2])
      }

      channel.port1.onmessage = (event) => {
        const data = event.data || {}
        switch (data.type) {
          case 'close':
            this.showChat = false
            break
          case 'zoom-in':
            this.isZoomIn = true
            break
          case 'zoom-out':
            this.isZoomIn = false
            break
          default:
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.deep-seek-from-servicequality {
  position: relative;
  z-index: 1002;
  .chat-container {
    width: 480px;
    position: fixed;
    right: 36px;
    top: 90px;
    bottom: 36px;
    transition: width 1s;
    z-index: 1;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0px 4px 30px 0px rgba(209, 213, 223, 0.7);
    transition: width 0.1s;
    text-align: right;
    &.is-zoom-in {
      width: 100vw;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
    iframe {
      width: 100%;
      height: 100%;
    }
  }
  .chat-trigger {
    width: 96px;
    height: 96px;
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 2;
    cursor: pointer;
    .chat-logo {
      max-width: 100%;
      max-height: 100%;
      pointer-events: none;
    }
  }
}
</style>
